import { render, staticRenderFns } from "./xskVideoManage.vue?vue&type=template&id=652edf10&scoped=true&"
import script from "./xskVideoManage.vue?vue&type=script&lang=js&"
export * from "./xskVideoManage.vue?vue&type=script&lang=js&"
import style0 from "./xskVideoManage.vue?vue&type=style&index=0&id=652edf10&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652edf10",
  null
  
)

export default component.exports